module.exports = __webpack_public_path__ + "static/media/OC2.c8893660.png";